module.exports = __webpack_public_path__ + "static/media/arrow-down.11cc68f0.svg";